import { Grow, IconButton } from '@material-ui/core'
import Popover from '@material-ui/core/Popover'
import { createStyles, makeStyles, type Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CallMadeIcon from '@material-ui/icons/CallMade'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined'
import type React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		typography: {
			padding: 0,
		},
	})
)

export default function HelpButton() {
	const classes = useStyles()
	const { t } = useTranslation()
	const { t: tGridNavbar } = useTranslation('GridNavbar')
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const open = Boolean(anchorEl)
	const id = open ? 'simple-popover' : undefined

	return (
		<div>
			<IconButton
				aria-label="help icon"
				aria-controls="menu-appbar"
				aria-haspopup="true"
				color="inherit"
				onClick={handleClick}
			>
				<HelpOutlineIcon />
			</IconButton>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				PaperProps={{
					style: { width: '30rem', padding: '16px' },
				}}
				style={{ padding: '1rem 1rem 2rem', marginTop: '0.25rem' }}
				TransitionComponent={Grow}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '1rem',
					}}
				>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<InsertDriveFileOutlinedIcon
							fontSize="small"
							style={{ color: 'gray', marginRight: '0.5rem' }}
						/>
						<Typography
							variant="h6"
							className={classes.typography}
							style={{
								fontSize: '1rem',
								fontWeight: 600,
							}}
						>
							{tGridNavbar('docs')}
						</Typography>
					</div>
					<div style={{ marginLeft: '1.75rem' }}>
						<Typography
							className={classes.typography}
							style={{
								color: 'gray',
								margin: '0.5rem 0',
								fontSize: '0.875rem',
								lineHeight: '1.75',
							}}
						>
							{tGridNavbar('helpButtonText')}
						</Typography>
						<a
							href="https://learn.chedar.io/"
							target="_blank"
							rel="noreferrer"
							style={{
								fontSize: '1rem',
								fontWeight: 700,
								display: 'flex',
								alignItems: 'center',
								color: '#364263',
								textDecoration: 'underline',
							}}
						>
							{tGridNavbar('vistDocs')}
							<CallMadeIcon
								fontSize="small"
								style={{
									fontSize: '1rem',
									marginLeft: '0.5rem',
								}}
							/>
						</a>
					</div>
				</div>
			</Popover>
		</div>
	)
}
